import { StandardAlert } from '@cimplico/components';
import { useState } from 'react';
import plural from '../../../utilities/plural';

type OnboardXeroEntitiesAlertProps = {
    successMessages?: string[];
    errorMessages?: string[];
    onSuccessAlertClose: () => void;
    onErrorAlertClose: () => void;
};

function OnboardingResultsBanner({
    successMessages,
    errorMessages,
    onSuccessAlertClose,
    onErrorAlertClose,
}: OnboardXeroEntitiesAlertProps): JSX.Element {
    const [viewMore, setViewMore] = useState(false);

    return (
        <div className="mb-4 flex flex-col gap-2">
            {successMessages && successMessages.length > 0 && (
                <StandardAlert
                    type="success"
                    title="Successfully completed the following actions:"
                    description={successMessages}
                    onClose={onSuccessAlertClose}
                >
                    <></>
                </StandardAlert>
            )}
            {errorMessages && errorMessages.length > 0 && (
                <StandardAlert
                    type="error"
                    title={`The following ${plural(errorMessages.length, 'error', 'errors')} occurred while mapping Xero entities:`}
                    description={!viewMore ? errorMessages.slice(0, 2) : errorMessages}
                    onClose={onErrorAlertClose}
                >
                    {errorMessages.length > 2 && !viewMore && (
                        <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View more</StandardAlert.Button>
                    )}
                    {errorMessages.length > 2 && viewMore && (
                        <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View less</StandardAlert.Button>
                    )}
                </StandardAlert>
            )}
        </div>
    );
}

export default OnboardingResultsBanner;
